var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.05033 12.1214L2.929 14.2428L5.75743 17.0712L17.0711 5.75743L14.2427 2.929L12.1214 5.05032L13.5356 6.46454L12.1214 7.87875L10.7072 6.46454L9.293 7.87875L10.7072 9.29296L9.293 10.7072L7.87875 9.29296L6.46454 10.7072L7.87875 12.1214L6.46454 13.5356L5.05033 12.1214ZM14.9498 0.80768L19.1925 5.05032C19.583 5.44085 19.583 6.07401 19.1925 6.46454L6.46454 19.1925C6.07401 19.583 5.44085 19.583 5.05033 19.1925L0.807678 14.9499C0.417158 14.5593 0.417158 13.9262 0.807678 13.5356L13.5356 0.80768C13.9261 0.41716 14.5593 0.41716 14.9498 0.80768ZM12.1214 16.3636L13.5356 14.9494L15.7781 17.1919H17.1923V15.7777L14.9498 13.5352L16.364 12.1209L18.9997 14.7566V19H14.7578L12.1214 16.3636ZM3.63597 7.87812L0.807538 5.04969C0.417018 4.65917 0.417018 4.026 0.807538 3.63548L3.63597 0.80705C4.02649 0.41653 4.65966 0.41653 5.05018 0.80705L7.87861 3.63548L6.4644 5.04969L4.34308 2.92837L2.92886 4.34259L5.05018 6.46391L3.63597 7.87812Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure);
export default __webpack_public_path__ + "static/media/measure.c42450cf0638779cd31370bcc86b90ef.svg";
export { ForwardRef as ReactComponent };